/**
 * Certificate utility functions
 * Copied from user_website_new/public/page1.js
 */

/**
 * Format number with commas (e.g., 1234567 -> "1,234,567")
 */
export function formatNumberWithCommas(x: number | string): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Format date to "19th Dec 2024" format
 */
export function getFormattedDate(date: string | Date): string {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  
  const update_time = new Date(date);
  const day = update_time.getDate();
  const month = months[update_time.getMonth()];
  const year = update_time.getFullYear();

  let dayWithSuffix: string;
  if (day >= 11 && day <= 13) {
    dayWithSuffix = day + "th";
  } else {
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        dayWithSuffix = day + "st";
        break;
      case 2:
        dayWithSuffix = day + "nd";
        break;
      case 3:
        dayWithSuffix = day + "rd";
        break;
      default:
        dayWithSuffix = day + "th";
    }
  }

  const formattedDate = `${dayWithSuffix} ${month} ${year}`;
  return formattedDate;
}

/**
 * Format date to 6-digit format DDMMYY (e.g., "191224" for Dec 19, 2024)
 */
export function get6DigitDate(fulldate: string | Date): string {
  const date = new Date(fulldate);

  // Get last two digits of year
  const year = date
    .getFullYear()
    .toString()
    .substr(-2);

  // Get month as two digits
  const month = ("0" + (date.getMonth() + 1)).slice(-2);

  // Get day as two digits
  const day = ("0" + date.getDate()).slice(-2);

  // Combine into 6-digit date format
  const sixDigitDate = day + month + year;

  return sixDigitDate;
}

